import React, {createContext, useContext, useReducer} from 'react'
import {InductCameraDeviceOverviewReducer} from "../reducer/InductCameraDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const InductCameraDeviceOverviewContext = createContext();

const InductCameraDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        asmlComponentInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(InductCameraDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }
    return (
        <InductCameraDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </InductCameraDeviceOverviewContext.Provider>
    )
}

export default InductCameraDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/context/InductCameraDeviceOverviewContext.js